function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#WhatsappIcon_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#WhatsappIcon_svg__pattern0)",
  d: "M4 2h18v18H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#WhatsappIcon_svg__pattern1)",
  d: "M5.016 2.978h15.895v15.936H5.016z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.375 18.42l1.074-3.913a7.527 7.527 0 01-1.01-3.775C5.44 6.568 8.835 3.18 13.008 3.18c2.024 0 3.924.787 5.354 2.214a7.5 7.5 0 012.214 5.343c-.002 4.163-3.397 7.551-7.568 7.551h-.004a7.576 7.576 0 01-3.616-.92l-4.013 1.05zm4.198-2.417l.23.136a6.295 6.295 0 003.202.875h.002c3.467 0 6.29-2.816 6.291-6.277a6.231 6.231 0 00-1.84-4.44 6.257 6.257 0 00-4.449-1.84c-3.47 0-6.292 2.815-6.293 6.275 0 1.186.332 2.341.962 3.34l.15.238-.636 2.316 2.381-.623z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.637 18.156l1.037-3.777a7.268 7.268 0 01-.976-3.645c.001-4.02 3.28-7.29 7.307-7.29 1.954.002 3.79.761 5.168 2.139a7.235 7.235 0 012.138 5.157c-.001 4.02-3.28 7.29-7.306 7.29h-.003a7.312 7.312 0 01-3.492-.888l-3.873 1.014z",
  fill: "url(#WhatsappIcon_svg__paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#WhatsappIcon_svg__pattern2)",
  d: "M4.906 2.761h16.113v16.153H4.906z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.375 18.42l1.074-3.913a7.527 7.527 0 01-1.01-3.775C5.44 6.568 8.835 3.18 13.008 3.18c2.024 0 3.924.787 5.354 2.214a7.5 7.5 0 012.214 5.343c-.002 4.163-3.397 7.551-7.568 7.551h-.004a7.576 7.576 0 01-3.616-.92l-4.013 1.05zm4.198-2.417l.23.136a6.295 6.295 0 003.202.875h.002c3.467 0 6.29-2.816 6.291-6.277a6.231 6.231 0 00-1.84-4.44 6.257 6.257 0 00-4.449-1.84c-3.47 0-6.292 2.815-6.293 6.275 0 1.186.332 2.341.962 3.34l.15.238-.636 2.316 2.381-.623z",
  fill: "url(#WhatsappIcon_svg__paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#WhatsappIcon_svg__pattern3)",
  d: "M8.719 6.853h8.601v8.04H8.719z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.115 7.575c-.142-.314-.29-.32-.426-.326-.11-.004-.236-.004-.363-.004a.697.697 0 00-.504.236c-.173.189-.662.646-.662 1.574 0 .929.678 1.826.772 1.952.095.126 1.309 2.093 3.231 2.85 1.598.628 1.923.503 2.27.472.347-.032 1.118-.457 1.276-.898.158-.44.158-.818.11-.897-.047-.079-.173-.126-.362-.22-.189-.095-1.119-.552-1.292-.614-.174-.063-.3-.095-.426.094-.126.19-.488.614-.599.74-.11.126-.22.142-.41.047-.189-.094-.798-.293-1.52-.936a5.683 5.683 0 01-1.052-1.307c-.11-.189-.012-.291.083-.385.085-.085.189-.22.284-.33.094-.111.125-.19.188-.316.064-.126.032-.236-.015-.33-.048-.095-.415-1.029-.583-1.402z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "WhatsappIcon_svg__pattern1",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#WhatsappIcon_svg__image1"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "WhatsappIcon_svg__pattern2",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#WhatsappIcon_svg__image2"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "WhatsappIcon_svg__pattern3",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#WhatsappIcon_svg__image3"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "WhatsappIcon_svg__pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#WhatsappIcon_svg__image0"
})), /*#__PURE__*/React.createElement("image", {
  id: "WhatsappIcon_svg__image3",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAO0AAADeCAYAAADRo4eMAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
}), /*#__PURE__*/React.createElement("image", {
  id: "WhatsappIcon_svg__image0",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfAAAAHxCAYAAACS8O5DAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
}), /*#__PURE__*/React.createElement("image", {
  id: "WhatsappIcon_svg__image1",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbYAAAG4CAYAAAApA8IAAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
}), /*#__PURE__*/React.createElement("image", {
  id: "WhatsappIcon_svg__image2",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbwAAAG+CAYAAADoeLHUAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "WhatsappIcon_svg__paint1_linear",
  x1: 12.976,
  y1: 18.42,
  x2: 12.976,
  y2: 3.181,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9F9F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "WhatsappIcon_svg__paint0_linear",
  x1: 12.974,
  y1: 18.156,
  x2: 12.974,
  y2: 3.445,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#20B038"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#60D66A"
})), /*#__PURE__*/React.createElement("filter", {
  id: "WhatsappIcon_svg__filter0_d",
  x: 0,
  y: 0,
  width: 26,
  height: 26,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgWhatsappIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgWhatsappIcon;